{% block prems_discount_category_detail_base %}
    <div>
        {% block prems_discount_category_detail_content_base %}
        <mt-card
            :title="$tc('prems-discount-category.detail.card.base.title')"
            :isLoading="isLoading"
        >
            <sw-container
                columns="2fr 1fr"
                gap="50px"
            >
                {% block prems_discount_category_detail_content_base_name_field %}
                <mt-text-field
                    v-model="discountCategory.name"
                    :label="$tc('prems-discount-category.detail.card.base.field.nameLabel')"
                    :error="discountCategoryNameError"
                    :placeholder="$tc('prems-discount-category.detail.card.base.field.namePlaceholder')"
                    required
                >
                    </mt-text-field>
                {% endblock %}

                {% block prems_discount_category_detail_content_base_active_field %}
                <mt-switch
                    v-model="discountCategory.active"
                    :label="$tc('prems-discount-category.detail.card.base.field.activeLabel')"
                >
                    </mt-switch>
                {% endblock %}
            </sw-container>
            <sw-container
                columns="1fr 1fr"
                gap="0px 30px"
            >
                {% block prems_discount_category_detail_content_base_valid_from_field %}
                <mt-datepicker
                    v-model="discountCategory.validFrom"
                    date-type="datetime"
                    :label="$tc('prems-discount-category.detail.card.base.field.validFromLabel')"
                />
                {% endblock %}

                {% block prems_discount_category_detail_content_base_valid_until_field %}
                <mt-datepicker
                    v-model="discountCategory.validUntil"
                    date-type="datetime"
                    :label="$tc('prems-discount-category.detail.card.base.field.validUntilLabel')"
                />
                {% endblock %}

                {% block prems_discount_category_detail_content_base_priority_field %}
                <mt-number-field
                    v-model="discountCategory.priority"
                    numberType="int"
                    :step="1"
                    :min="0"
                    :label="$tc('prems-discount-category.detail.card.base.field.priorityLabel')"
                    :placeholder="$tc('prems-discount-category.detail.card.base.field.priorityPlaceholder')"
                >
                    </mt-number-field>
                {% endblock %}

                {% block prems_discount_category_detail_content_base_valid_until_visibility_field %}
                    <sw-multi-select
                        v-if="discountCategory.validUntil"
                        class="prems-discount-category-detail-base__valid-until-visibility"
                        v-model:value="validUntilVisibility"
                        :label="$tc('prems-discount-category.detail.card.base.field.validUntilVisibilityLabel')"
                        :options="validUntilVisibilityOptions">
                    </sw-multi-select>
                {% endblock %}
            </sw-container>
            <sw-container
                columns="1fr 1fr"
                gap="0px 30px"
            >
                {% block prems_discount_category_detail_content_base_show_discount_badge_in_listing_field %}
                <mt-switch
                    v-model="discountCategory.showDiscountBadgeInListing"
                    :label="$tc('prems-discount-category.detail.card.base.field.showDiscountBadgeInListing')"
                >
                    </mt-switch>
                {% endblock %}

                {% block prems_discount_category_detail_content_base_show_discount_infobox_in_listing_field %}
                <mt-switch
                    v-model="discountCategory.showDiscountInfoboxInListing"
                    :label="$tc('prems-discount-category.detail.card.base.field.showDiscountInfoboxInListing')"
                >
                    </mt-switch>
                {% endblock %}

                {% block prems_discount_category_detail_content_base_show_discount_infobox_on_detailpage_field %}
                <mt-switch
                    v-model="discountCategory.showDiscountInfoboxOnDetailpage"
                    :label="$tc('prems-discount-category.detail.card.base.field.showDiscountInfoboxOnDetailpage')"
                >
                    </mt-switch>
                {% endblock %}
            </sw-container>
        </mt-card>
        {% endblock %}

        {# Badge card #}
        {% block prems_discount_category_badge_in_listing %}
        <mt-card
            v-if="discountCategory.showDiscountBadgeInListing"
            :title="$tc('prems-discount-category.detail.card.badge-in-listing.title')"
            :isLoading="isLoading"
        >
            <sw-container>
                {% block prems_discount_category_detail_content_badge_in_listing_text_field %}
                <mt-text-field
                    v-model="discountCategory.listingBadgeTitle"
                    :label="$tc('prems-discount-category.detail.card.badge-in-listing.field.badgeTextLabel')"
                    :placeholder="$tc('prems-discount-category.detail.card.badge-in-listing.field.badgeTextPlaceholder')"
                >
                        </mt-text-field>
                {% endblock %}
            </sw-container>
            <sw-container
                columns="1fr 1fr"
                gap="0px 30px"
            >
                {% block prems_discount_category_detail_content_badge_in_listing_text_color_field %}
                <mt-colorpicker
                    v-model="discountCategory.listingBadgeTextColor"
                    colorOutput="auto"
                    :label="$tc('prems-discount-category.detail.card.badge-in-listing.field.badgeTextColorLabel')"
                    :alpha="true"
                    :colorLabels="true"
                    :zIndex="100"
                ></mt-colorpicker>
                {% endblock %}

                {% block prems_discount_category_detail_content_badge_in_listing_background_field %}
                <mt-colorpicker
                    v-model="discountCategory.listingBadgeBackgroundColor"
                    colorOutput="auto"
                    :label="$tc('prems-discount-category.detail.card.badge-in-listing.field.badgeBackgroundColorLabel')"
                    :alpha="true"
                    :colorLabels="true"
                    :zIndex="100"
                ></mt-colorpicker>
                {% endblock %}
            </sw-container>
        </mt-card>
        {% endblock %}

        {# Badge card #}
        {% block prems_discount_category_infobox_in_listing %}
        <mt-card
            v-if="discountCategory.showDiscountInfoboxInListing"
            :title="$tc('prems-discount-category.detail.card.infobox-in-listing.title')"
            :isLoading="isLoading"
        >
            <div class="prems-discount-category-detail_listing-infobox-title">
                <em>
                    {{ $tc('prems-discount-category.detail.card.infobox-in-listing.helpTextTitle') }}
                </em>
            </div>
            <sw-container
                columns="2fr 1fr"
                gap="0px 30px"
            >
                {% block prems_discount_category_detail_content_infobox_in_listing_title_field %}
                <mt-text-field
                    v-model="discountCategory.listingInfoboxTitle"
                    :label="$tc('prems-discount-category.detail.card.infobox-in-listing.field.titleLabel')"
                    :placeholder="$tc('prems-discount-category.detail.card.infobox-in-listing.field.titlePlaceholder')"
                >
                        </mt-text-field>
                {% endblock %}
                {% block prems_discount_category_detail_content_infobox_in_listing_title_switch %}
                <mt-switch
                    v-model="discountCategory.listingInfoboxIcon"
                    :label="$tc('prems-discount-category.detail.card.infobox-in-listing.field.showInfoIcon')"
                >
                        </mt-switch>
                {% endblock %}
            </sw-container>
            <sw-container>
                {% block prems_discount_category_detail_content_infobox_in_listing_text_field %}
                <sw-text-editor
                    v-model:value="discountCategory.listingInfoboxText"
                    :label="$tc('prems-discount-category.detail.card.infobox-on-detailpage.field.textLabel')"
                    :placeholder="$tc('prems-discount-category.detail.card.infobox-on-detailpage.field.textPlaceholder')"
                >
                        </sw-text-editor>
                {% endblock %}
            </sw-container>
            <sw-container
                columns="1fr 1fr"
                gap="0px 30px"
            >
                    {% block prems_discount_category_detail_content_infobox_in_listing_text_color_field %}
                <mt-colorpicker
                    v-model="discountCategory.listingInfoboxTextColor"
                    colorOutput="auto"
                    :label="$tc('prems-discount-category.detail.card.infobox-in-listing.field.textColorLabel')"
                    :alpha="true"
                    :colorLabels="true"
                    :zIndex="100"
                ></mt-colorpicker>
                {% endblock %}

                {% block prems_discount_category_detail_content_infobox_in_listing_background_field %}
                <mt-colorpicker
                    v-model="discountCategory.listingInfoboxBackgroundColor"
                    colorOutput="auto"
                    :label="$tc('prems-discount-category.detail.card.infobox-in-listing.field.backgroundColorLabel')"
                    :alpha="true"
                    :colorLabels="true"
                    :zIndex="100"
                ></mt-colorpicker>
                {% endblock %}
                    {% block prems_discount_category_detail_content_category_select %}
                <prems-discount-category-selector :discount-category="discountCategory"></prems-discount-category-selector>
                {% endblock %}
                    {% block prems_discount_category_detail_content_category_exclude_switch %}
                <mt-select
                    :label="$tc('prems-discount-category.detail.card.base.field.categoryIdsModeLabel')"
                    v-model="discountCategory.categoryIdsMode"
                    required
                    :options="categoryIdsModeOptions"
                ></mt-select>
                {% endblock %}
            </sw-container>
        </mt-card>
        {% endblock %}

        {# Infobox card #}
        {% block prems_discount_category_infobox_on_detailpage %}
        <mt-card
            v-if="discountCategory.showDiscountInfoboxOnDetailpage"
            :title="$tc('prems-discount-category.detail.card.infobox-on-detailpage.title')"
            :isLoading="isLoading"
        >
            <sw-container
                columns="2fr 1fr"
                gap="0px 30px"
            >
                {% block prems_discount_category_detail_content_infobox_on_detailpage_title_field %}
                <mt-text-field
                    v-model="discountCategory.detailpageInfoboxTitle"
                    :label="$tc('prems-discount-category.detail.card.infobox-on-detailpage.field.titleLabel')"
                    :placeholder="$tc('prems-discount-category.detail.card.infobox-on-detailpage.field.titlePlaceholder')"
                >
                        </mt-text-field>
                {% endblock %}
                    {% block prems_discount_category_detail_content_infobox_on_detailpage_title_switch %}
                <mt-switch
                    v-model="discountCategory.detailpageInfoboxIcon"
                    :label="$tc('prems-discount-category.detail.card.infobox-on-detailpage.field.showInfoIcon')"
                >
                        </mt-switch>
                {% endblock %}
            </sw-container>
            <sw-container>
                {% block prems_discount_category_detail_content_infobox_on_detailpage_text_field %}
                <sw-text-editor
                    v-model:value="discountCategory.detailpageInfoboxText"
                    :label="$tc('prems-discount-category.detail.card.infobox-on-detailpage.field.textLabel')"
                    :placeholder="$tc('prems-discount-category.detail.card.infobox-on-detailpage.field.textPlaceholder')"
                >
                        </sw-text-editor>
                {% endblock %}
            </sw-container>
            <sw-container
                columns="1fr 1fr"
                gap="0px 30px"
            >
                {% block prems_discount_category_detail_content_infobox_on_detailpage_text_color_field %}
                <mt-colorpicker
                    v-model="discountCategory.detailpageInfoboxTextColor"
                    colorOutput="auto"
                    :label="$tc('prems-discount-category.detail.card.infobox-on-detailpage.field.textColorLabel')"
                    :alpha="true"
                    :colorLabels="true"
                    :zIndex="100"
                ></mt-colorpicker>
                {% endblock %}

                {% block prems_discount_category_detail_content_infobox_on_detailpage_background_field %}
                <mt-colorpicker
                    v-model="discountCategory.detailpageInfoboxBackgroundColor"
                    colorOutput="auto"
                    :label="$tc('prems-discount-category.detail.card.infobox-on-detailpage.field.backgroundColorLabel')"
                    :alpha="true"
                    :colorLabels="true"
                    :zIndex="100"
                ></mt-colorpicker>
                {% endblock %}
            </sw-container>
        </mt-card>
        {% endblock %}

        {% block prems_discount_category_detail_content_discount_products %}
        <mt-card
            :title="$tc('prems-discount-category.detail.card.discountProducts.title')"
            :isLoading="isLoading"
        >
            <sw-container>
                {% block prems_discount_category_detail_content_discount_products_dynamic_product_group_select_field %}
                <sw-entity-single-select
                    v-model:value="discountCategory.discountProductStreamId"
                    entity="product_stream"
                    :label="$tc('prems-discount-category.detail.card.discountProducts.field.dynamicProductGroupLabel')"
                    :placeholder="$tc('prems-discount-category.detail.card.discountProducts.field.dynamicProductGroupPlaceholder')"
                >
                    </sw-entity-single-select>
                {% endblock %}
            </sw-container>
        </mt-card>
        {% endblock %}
    </div>
{% endblock %}